
import React, { useEffect, useState } from 'react';
import '../../App.css';
import { Redirect, withRouter, Link } from "react-router-dom";
import { url } from '../../utils';
// import heroImage1 from '../../viblica_illustration.png'
import heroImage2 from '../../assets/images/undraw_videographer_nnc7.svg'
// import heroImage3 from '../../assets/images/undraw_taking_selfie_lbo7.svg'
import { Form } from "antd";
import LiveEventsHero from './LiveEventsHero';
import TrustedBrands from './TrustedBrands';
import TrustedBrandsPlain from './TrustedBrandsPlain';
import logo from "../../assets/images/logo_transparent_cut_landscape.png";
import Carousel from '../StreamCarousel';
import { isMobile } from 'react-device-detect';
import Header from './Header';


const heroMessages = [
  // {
  //   title: `Broadcast events to multiple platforms.`,
  //   description: `Live video streaming solution designed for businesses, broadcasters, gamers, religious organizations.`
  // },
  // {
  //   title: `Monetize your events`,
  //   description: `Yeah its that simple. Just set a price for an event and start earning from viewers`
  // },
  {
    title: "Stream Out Loud!!!",
    // description: `Live video streaming solution designed for businesses, broadcasters, gamers, educational and religious organizations.`

    description: `Experience real-time streaming with seamless support for all social media platforms, perfect for businesses, broadcasters, gamers, educators, and religious organizations.`
  },
  // {
  //   title: "Watch events unfold in real time",
  //   // description: `Live video streaming solution designed for businesses, broadcasters, gamers, educational and religious organizations.`

  //   description: `Stream in near real time with low latency. With a support to almost all social media channels`
  // },
  {
    title: "Livestream, Broadcast & more",
    description: `Unleash your creativity with a versatile platform designed for all your content needs. Go live, upload videos, and monetize premium content effortlessly.`

    // description: `Connect with the world's latest and greatest live content. Join us for an immersive streaming experience like never before`
  },
  {
    title: "Monetize Content Effortlessly",
    description: `Transform your content into a revenue. Easily set paywalls and let handle the rest.`

    // description: `Connect with the world's latest and greatest live content. Join us for an immersive streaming experience like never before`
  }
]


function HeroIntro(props){
  const [heroMessage, setHeroMessage] = useState({});
  const [heroImage, setHeroImage] = useState("");
  const [email, setEmail] = useState("");
  
  const getStarted = () => {
    // console.log(email);
    const path = url(`signup?eml=${email}`);
    return props.history.push(path)
  }


  const generateWelcomeMessage = () => {
    var luckyHero = heroMessages[Math.floor(Math.random() * heroMessages.length)];
    return setHeroMessage(luckyHero);
  }

  const pickImage = () => {
    const images = [heroImage2];
    var luckyImage = images[Math.floor(Math.random() * images.length)];
    console.log(luckyImage)
    return setHeroImage(luckyImage);
  }


  useEffect(() => {
    generateWelcomeMessage();
    pickImage();
  }, [])
  return <>
      <div className='flex flex-column bg-gray-800 hidden lg:block'>
            <div className='mx-auto'>
              <Link className="home-logo-link" to="/" style={{ marginLeft: '0.5rem' }}>
                {/* <span className="app-logo-text">{environments.app.name}</span> */}
                <img alt="" className="img-fluid logo  mx-auto" src={logo} />
              </Link>
            </div>

            <div className="flex  px-4 pb-16 sm:px-6 lg:px-8 lg:pb-4 xl:pr-12 ">

              <div className="max-w-lg mx-auto lg:mx-0">
                {/* <p className="text-4xl sm:text-6xl lg:text-5xl">📺🎥</p> */}
                <div className="mt-10  font-bold text-gray-300 text-2xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-relaxed" >{heroMessage['title']}</div>
                <p className="mt-6 my-4 text-3xl text-sm xs:text-base sm:text-base md:text-2xl lg:text-3xl font-normal text-base font-normal leading-tight lg:leading-snug  text-gray-400">{heroMessage['description']}</p>
                <div className='mt-3'>

                  <TrustedBrandsPlain />
                </div>
                <div className="relative inline-flex mt-10 group">
                  <div className="absolute transitiona-all duration-1000 opacity-70 inset-0 bg-gradient-to-r from-[#44BCFF] via-[#FF44EC] to-[#FF675E] rounded-xl blur-lg filter group-hover:opacity-100 group-hover:duration-200"></div>

                  <Link to={"/login"}
                    className="inline-flex relative items-center justify-center w-full sm:w-auto px-8 py-3 sm:text-sm text-base sm:py-3.5 font-semibold text-white transition-all duration-200 bg-gray-900 border border-transparent rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                  >
                    Start Streaming
                  </Link>
                </div>

              </div>
            </div>
          </div>
          
  </>
}


function Hero(props) {


 

  
  return (
    <div className="relative " style={{maxHeight:"50.5rem"}}>
     
      <section className="relative bg-gray-900 py-0">
        <div className="absolute inset-0">
          <div className="absolute inset-y-0 left-0 w-1/2 bg-white"></div>
        </div>

       <div className="relative mx-auto max-w-8xl grid grid-cols-3">
          {/* <LiveEventsHero /> */}
          {/* <div className='col-span-2'> */}
          { <Carousel/>}
          { <HeroIntro/>}

          {/* </div> */}
      


        </div>
        
      </section>
    </div>


  )
}


export default withRouter(Hero)